/**
 * @description: 寄存管理
 * @author: hwx
 * @update: lyr(2022-03-15)
 */
<template>
	<div class="deposit-manage-wrap">
		<div class="deposit-list" v-show="showDepsit">
			<div class="row row-margin">
				<label class="ct-label">时间:</label>
				<div class="col-md-3" style="width: 335px;">
					<div id="time-wrapper" @click="clearDate" ref="deposit_time">
						<input type="text" class="form-control laydate-icon" id="start-time" v-model="startTime" style="display:inline-block; width: 145px;"> -
						<input type="text" class="form-control laydate-icon" id="end-time" v-model="endTime" style="display:inline-block; width: 145px;">
					</div>
				</div>
				<label class="ct-label">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="deposit_shop" data-placeholder="请选择门店"></select>
				</div>
				<label class="ct-label">类型:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="deposit_type">
						<option value=" ">全部</option>
						<option value="1">自助寄存</option>
						<option value="2">呼叫寄存</option>
						<option value="3">服务员添加寄存</option>
					</select>
				</div>
				<div class="col-md-1 ct-col deposit-tit-sel">
					<select class="form-control" ref="deposit_tit_sel">
						<option value="mobile">手机号</option>
						<option value="user_name">姓名</option>
						<option value="number">存单单号</option>
						<option value="take_code">存酒码</option>
					</select>
				</div>
				<div class="col-md-2 deposit-con-val">
					<input type="text" class="form-control temp-readonly" v-model="deposit_con_val" :placeholder="deposit_con_phd" autocomplete="off" readonly
 onfocus="this.removeAttribute('readonly')" onblur="this.setAttribute('readonly', true)">
				</div>
			</div>
			<div class="row">
				<label class="ct-label">状态:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="deposit_status">
						<option value=" ">全部</option>
						<option value="1">审核中</option>
						<option value="2">无效</option>
						<option value="3">有效</option>
						<option value="4">配送中</option>
						<option value="5">已取</option>
						<option value="6">过期</option>
						<!-- <option value="7">完成</option> -->
						<!-- <option value="8">呼叫成功</option> -->
						<option value="10">等待接收中</option>
					</select>
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="depositClear" v-if="list_menu_clear">清空寄存单</button>
					<a href="https://vodonline.oss-cn-beijing.aliyuncs.com/uploads/importxls/%E5%B7%A8%E5%97%A8%E5%AF%84%E5%AD%98%E5%AF%BC%E5%85%A5.xls" class="btn btn-flat btn-middle btn-orange" v-if="list_menu_import">存取酒模板下载</a>
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="addXlsFun" v-if="list_menu_import">存取酒模板导入</button>
					<input type="file" @change="uploadDepositXls($event)" id="depositXlsFile" ref="depositXlsFile">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="getExportSet">导出</button>
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clkQuery">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="deposit_list"></table>
			</div>
			<!-- 清空寄存单 -->
			<div class="deposit-clear-alert" ref="deposit_clear_alert">
				<p class="notice">注：该操作将清空所有寄存单据，但寄存仓库库存数量不会扣减，如需调整库存数据请使用库存盘点操作清零！</p>
				<p class="tip">确认清空寄存单？清空后将不可恢复！</p>
				<el-input type="password" placeholder="请输入操作人登录密码" v-model="deposit_clear_pwd"></el-input>
				<div class="oper-log-title">操作日志</div>
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="deposit_oper_log"></table>
			</div>
			<!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="export_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="number">
                            <label>存酒单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="take_code">
                            <label>存酒码</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="create_time">
                            <label>寄存时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="approve_time">
                            <label>审核时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="end_time">
                            <label>到期时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="user_name">
                            <label>用户姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="ahead_user_name">
                            <label>微信昵称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="mobile">
                            <label>手机号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="status_name">
                            <label>寄存单状态</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='export_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='export_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
		</div>
		<div class="deposit-det" v-show="showDepsitDet">
			<div class="row">
				<button type="button" class="btn btn-flat btn-small btn-orange" @click="backList">返回</button>
			</div>
			<div class="deposit-det-list">
				<h2>存酒单详情 - {{det_status}}</h2>
				<div class="row clearfix" v-if="theDeposit.status == '1'">
					<div class="col-md-4">
						<label class="col-md-4">门店：</label>
						<span class="col-md-8">{{theDeposit.shop_name}}</span>
						<label class="col-md-4">寄存来源：</label>
						<span class="col-md-8">{{theDeposit.type_name}}</span>
						<label class="col-md-4">用户姓名：</label>
						<span class="col-md-8">{{theDeposit.user_name}}</span>
					</div>
					<div class="col-md-4">
						<label class="col-md-4">寄存包厢：</label>
						<span class="col-md-8">{{theDeposit.room_name}}</span>
						<label class="col-md-4">微信昵称：</label>
						<span class="col-md-8">{{theDeposit.ahead_user_name}}</span>
						<label class="col-md-4">备注：</label>
						<span class="col-md-8">{{theDeposit.remark}}</span>
						<label class="col-md-4">预定人：</label>
						<span class="col-md-8">{{theDeposit.book_admin_name}}</span>
					</div>
					<div class="col-md-4">
						<label class="col-md-4">存酒单号：</label>
						<span class="col-md-8">{{theDeposit.number}}</span>
						<label class="col-md-4">手机号：</label>
						<span class="col-md-8">{{theDeposit.mobile}}</span>
						<label class="col-md-4">存酒码：</label>
						<span class="col-md-8">{{theDeposit.take_code}}</span>
					</div>
				</div>
				<div class="row clearfix" v-else>
					<div class="col-md-4">
						<label class="col-md-4">门店：</label>
						<span class="col-md-8">{{theDeposit.shop_name}}</span>
						<label class="col-md-4" v-if="theDeposit.status == '6' || theDeposit.status == '7'">更新时间：</label>
						<span class="col-md-8" v-if="theDeposit.status == '6' || theDeposit.status == '7'">{{theDeposit.update_time}}</span>
						<label class="col-md-4">寄存来源：</label>
						<span class="col-md-8">{{theDeposit.type_name}}</span>
						<label class="col-md-4">用户姓名：</label>
						<span class="col-md-8">{{theDeposit.user_name}}</span>
						<label class="col-md-4">备注：</label>
						<span class="col-md-8">{{theDeposit.remark}}</span>
						<label class="col-md-4">预定人：</label>
						<span class="col-md-8">{{theDeposit.book_admin_name}}</span>
					</div>
					<div class="col-md-4">
						<label class="col-md-4">寄存包厢：</label>
						<span class="col-md-8">{{theDeposit.room_name}}</span>
						<label class="col-md-4" v-if="theDeposit.status == '4' || theDeposit.status == '7'">配送包厢：</label>
						<span class="col-md-8" v-if="theDeposit.status == '4' || theDeposit.status == '7'">{{theDeposit.to_room_name}}</span>
						<label class="col-md-4">寄存时间：</label>
						<span class="col-md-8">{{theDeposit.create_time}}</span>
						<label class="col-md-4" v-if="theDeposit.status == '2'">不通过时间：</label>
						<span class="col-md-8" v-if="theDeposit.status == '2'">{{theDeposit.update_time}}</span>
						<label class="col-md-4" v-if="theDeposit.status != '2'">寄存服务员：</label>
						<span class="col-md-8" v-if="theDeposit.status != '2'">{{theDeposit.server_name}}</span>
						<label class="col-md-4">微信昵称：</label>
						<span class="col-md-8">{{theDeposit.ahead_user_name}}</span>
					</div>
					<div class="col-md-4">
						<label class="col-md-4">存酒单号：</label>
						<span class="col-md-8">{{theDeposit.number}}</span>
						<label class="col-md-4">到期时间：</label>
						<span class="col-md-8">{{theDeposit.end_time}}</span>
						<label class="col-md-4">寄存操作人：</label>
						<span class="col-md-8">{{theDeposit.admin_name}}</span>
						<label class="col-md-4">手机号：</label>
						<span class="col-md-8">{{theDeposit.mobile}}</span>
						<label class="col-md-4">存酒码：</label>
						<span class="col-md-8">{{theDeposit.take_code}}</span>
					</div>
				</div>
			</div>
			<div class="table-responsive">
				<h3>寄存详情</h3>
				<table class="table table-bordered table-hover" data-pagination="true" ref="depositDetTable"></table>
			</div>
			<div class="table-responsive" v-show="theDeposit.take_goods && theDeposit.take_goods.length != '0'">
				<h3 v-if="theDeposit.status != '4'">取酒详情</h3>
				<h3 v-if="theDeposit.status == '4'">配送详情</h3>
				<table class="table table-bordered table-hover" data-pagination="true" ref="depositWineTable"></table>
			</div>
			<div class="table-responsive">
				<h3>操作记录</h3>
				<table class="table table-bordered table-hover" data-pagination="true" ref="depositDetOperLogTable"></table>
			</div>
		</div>
		<!-- 新增、修改 -->
		<div class="deposit-edit" ref="deposit_edit">
			<div class="row">
				<p>手动充公后存酒单不可再操作取酒，确定手动充公？</p>
				<label class="col-md-3">充公仓库：</label>
				<div class="col-md-9 ct-col">
					<select class="form-control" data-placeholder="请选择充公仓库" ref="deposit_edit_store">
						<option value=""></option>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'order_manage',
		data() {
			return {
				list_menu_clear: false,
				list_menu_import: false,
				showDepsit: true,
				showDepsitDet:  false,
				startTime: '',
				endTime: '',
				deposit_field: "mobile",
				deposit_con_phd: "请输入手机号",
				deposit_con_val: "",
				export_allcheck: false,
                c_export_allcheck: false,
                export_checkModel: [],
                export_checkData: ['shop_name', 'number', 'take_code', 'create_time', 'approve_time', 'end_time', 'user_name', 'ahead_user_name', 'mobile', 'status_name'],
                export_type: 1,
				deposit_clear_pwd: '',

				det_status: '',
				theDeposit: {},
				oper_log_list: [], // 清空操作日志
			}
		},
		watch: {
			export_checkModel: {
                handler: function(val, oldVal) {
                    if(this.export_checkModel.length >= this.export_checkData.length) {
                        this.export_allcheck = true;
                        this.c_export_allcheck = true;
                    } else {
                        this.export_allcheck = false;
                        this.c_export_allcheck = false;
                    }
                },
                deep: true
            },
            '$route': {
                handler: function(val, oldVal) {
                    if(val.params.deposit_id) {
                        this.getDepositDet(val.params.deposit_id);
						this.showDepsit = false;
						this.showDepsitDet = true;
                    }
                },
                deep: true
            },
		},
		mounted: function() {
			this.getMenuOp()
			let _this = this;
			// 日期
			let myDate = new Date();
			_this.IntstartTime = myDate;
			_this.IntendTime = new Date(myDate.getTime() + 1 * 24 * 3600 * 1000);
			_this.IntstartTime.setHours(8, 0);
			_this.IntendTime.setHours(8, 0);
			let timStar = new Date(this.IntstartTime),
				year = timStar.getFullYear(),
				month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth() + 1),
				day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate(),
				hour = timStar.getHours() < 10 ? '0' + timStar.getHours() : timStar.getHours(),
				minute = timStar.getMinutes() < 10 ? '0' + timStar.getMinutes() : timStar.getMinutes();
			let timEnd = new Date(this.IntendTime),
				yearend = timEnd.getFullYear(),
				monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
				dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate(),
				hourend = timEnd.getHours() < 10 ? '0' + timEnd.getHours() : timEnd.getHours(),
				minuteend = timEnd.getMinutes() < 10 ? '0' + timEnd.getMinutes() : timEnd.getMinutes();
			_this.startTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
			_this.endTime = yearend + '-' + monthend + '-' + dayend + ' ' + hourend + ':' + minuteend;
			_this.innitDate(); // 日期
			
			_this.getShopData();
			$(_this.$refs.deposit_type).select2({
				language: "zh-CN",
				minimumResultsForSearch: -1,
			});
			$(_this.$refs.deposit_status).select2({
				language: "zh-CN",
				minimumResultsForSearch: -1,
			});
			// 下拉选项
			$(_this.$refs.deposit_tit_sel).select2({
				language: "zh-CN",
				minimumResultsForSearch: -1,
				width: '100%'
			}).change(function() {
				_this.deposit_field = $(this).val();
				if(_this.deposit_field == 'mobile') {
					_this.deposit_con_phd = '请输入手机号';
				} else if(_this.deposit_field == 'user_name') {
					_this.deposit_con_phd = '请输入姓名';
				} else if(_this.deposit_field == 'number') {
					_this.deposit_con_phd = '请输入存单单号';
				} else if(_this.deposit_field == 'take_code') {
					_this.deposit_con_phd = '请输入存酒码';
				}
			});

			// 第一次打开
			if(!!_this.$route.params.deposit_id) {
               	_this.getDepositDet(_this.$route.params.deposit_id);
				_this.showDepsit = false;
				_this.showDepsitDet = true;
            }
		},
		methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = JSON.parse(this.$store.state.menunew);

				menu.forEach(f => {
					if(f.id == '543') {
						menu = f.submenu
						menu.forEach(s => {
							if(s.id == '689') {
								menu = s.submenu
							}
						})
					}
				})
				menu.forEach(_ => {
					if(_.id == '951') {
						_this.list_menu_clear = true
					}
					if (_.id == '1050') { // 导入、下载
						_this.list_menu_import = true
					}
				})
			},
			// 初始化日期插件
			innitDate: function() {
				let _this = this;
				$(_this.$refs.deposit_time).daterangepicker({
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: _this.IntstartTime,
					endDate: _this.IntendTime
				}, function(start, end, label) {
					_this.startTime = start.format('YYYY-MM-DD HH:mm');
					_this.endTime = end.format('YYYY-MM-DD HH:mm');
				});
			},
			// 清空日期
			clearDate: function() {
				this.startTime = "";
				this.endTime = "";
			},
			// 获取门店数据
			getShopData: function() {
				let _this = this;

				let shopDatas = [];
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result, function(k, v) {
								shopDatas.push({ id: v.id, text: v.name });
							});
							shopDatas.shift();
							$(_this.$refs.deposit_shop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN"
							});
							_this.initTable();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 初始化列表
			initTable: function() {
				let _this = this;
				$(_this.$refs.deposit_list).bootstrapTable("destroy");
				$(_this.$refs.deposit_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "index",
						title: "行号",
						width: "3%",
						valign: "middle",
						formatter: function(value, row, index) {
							return index + 1;
						}
					}, {
						field: "shop_name",
						title: "门店",
						width: "8%"
					}, {
						field: "number",
						title: "存酒单号",
						width: "8%"
					}, {
						field: "take_code",
						title: "存酒码",
						width: "5%"
					}, {
						field: "create_time",
						title: "寄存时间",
						width: "8%"
					}, {
						field: "approve_time",
						title: "审核时间",
						width: "8%"
					}, {
						field: "revise_expire_times",
						title: "修改到期时间次数",
						width: "5%"
					}, {
						field: "end_time",
						title: "到期时间",
						width: "8%"
					}, {
						field: "user_name",
						title: "用户姓名",
						width: "6%"
					}, {
						field: "ahead_user_name",
						title: "微信昵称",
						width: "8%"
					}, {
						field: "mobile",
						title: "手机号",
						width: "8%"
					}, {
						field: "status_name",
						title: "寄存单状态",
						width: "5%"
					}, {
						title: "操作",
						width: "10%",
						events: {
							'click .det': function(e, value, row) {
								_this.det_status = row.status_name;
								_this.getDepositDet(row.id);
								_this.showDepsit = false;
								_this.showDepsitDet = true;
							},
							'click .status': function(e, value, row) {
								if(row.is_confiscate == '-1') {
									_this.getShopStore(row.shop_id);
									_this.selStore(row.is_confiscate, row.id);
								} else {
									_this.cgConf(row.is_confiscate, row.id);
								}
							}
						},
						formatter: function(value, row, index) {
							if(row.status != '6') {
								return '<span class="text-blue det">详情</span>';
							} else {
								let confText = (row.is_confiscate == 1) ? '取消充公' : '手动充公';
								return '<span class="text-blue det">详情</span><span class="text-blue status">'+ confText +'</span>';
							}
						}
					}],
				});
			},
			// 表格数据
			getList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let mobile = "",
					user_name = "",
					number = "",
					take_code = "";
				if(_this.deposit_field == 'mobile') {
					mobile = _this.deposit_con_val;
				} else if(_this.deposit_field == 'user_name') {
					user_name = _this.deposit_con_val;
				} else if(_this.deposit_field == 'number') {
					number = _this.deposit_con_val;
				} else if(_this.deposit_field == 'take_code') {
					take_code = _this.deposit_con_val;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"start_time": _this.startTime,
							"end_time": _this.endTime,
							"shop_id": $(_this.$refs.deposit_shop).val(),
							"type": $.trim($(_this.$refs.deposit_type).val()),
							"status": $.trim($(_this.$refs.deposit_status).val()),
							"mobile": mobile,
							"user_name": user_name,
							"number": number,
							"take_code": take_code
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Deposit/searchDepositList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			clkQuery: function() {
				this.initTable();
			},
			// 获取导出设置
            getExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "Deposit/exportDepositList"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.export_checkModel = data.response.result.export_fields;
                                _this.export_type = data.response.result.export_type;
                            } else {
                                _this.export_checkModel = _this.export_checkData;
                                _this.export_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.export_alert)
                }, function() {
                    _this.depositExport();
                });
            },
            // 导出字段全选
            exportCheckedAll: function() {
                let _this = this;
                _this.export_allcheck = _this.c_export_allcheck;
                if(!_this.export_allcheck) { // 实现全选
                    _this.export_checkModel = [];
                    _this.export_checkData.forEach(function(item) {
                        _this.export_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.export_checkModel = [];
                }
            },
            // 点击导出
            depositExport: function() {
				let _this = this;
				let export_fields = JSON.stringify(_this.export_checkModel);
				let mobile = "",
					user_name = "",
					number = "",
					take_code = "";
				if(_this.deposit_field == 'mobile') {
					mobile = _this.deposit_con_val;
				} else if(_this.deposit_field == 'user_name') {
					user_name = _this.deposit_con_val;
				} else if(_this.deposit_field == 'number') {
					number = _this.deposit_con_val;
				} else if(_this.deposit_field == 'take_code') {
					take_code = _this.deposit_con_val;
				}
                window.location.href = Vue.ctUrl + "Deposit/exportDepositList?" +
                    "start_time=" + _this.startTime +
                    "&end_time=" + _this.endTime +
                    "&shop_id=" + $(_this.$refs.deposit_shop).val() +
                    "&type=" + $.trim($(_this.$refs.deposit_type).val()) +
                    "&status=" + $.trim($(_this.$refs.deposit_status).val()) +
                    "&mobile=" + mobile +
                    "&user_name=" + user_name +
                    "&number=" + number +
                    "&take_code=" + take_code +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.export_type;
                layer.msg("导出成功！");
                layer.closeAll();
            },

            // 初始化清空操作日志
			initOperLogTable: function() {
				let _this = this;
				$(_this.$refs.deposit_oper_log).bootstrapTable("destroy");
				$(_this.$refs.deposit_oper_log).bootstrapTable({
					columns: [ {
						field: "create_time",
						title: "时间",
						width: "50%"
					}, {
						field: "admin_name",
						title: "操作人",
						width: "50%"
					}],
					data: _this.oper_log_list
				});
			},

			getOperLogList: function() {
				const _this = this
				Vue.axios.post('Deposit/getDelLog', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"shop_id": $(_this.$refs.deposit_shop).val(),
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							_this.oper_log_list = res.data.response.result
							_this.initOperLogTable()
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					})
			},

			// 清空寄存单
			depositClear() {
				const _this = this

				_this.deposit_clear_pwd = ''
				_this.getOperLogList()
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], //按钮
					title: ['清空寄存单', true],
					area: ['500px', '500px'], //宽高
					content: $(_this.$refs.deposit_clear_alert),
					offset: '100px'
				}, function() {
					Vue.axios.post('Deposit/delAllDeposit', {
						"header": Vue.request_header,
						"request": {
							"param": {
								"shop_id": $(_this.$refs.deposit_shop).val(),
								"password": _this.deposit_clear_pwd
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('操作成功')
							$(_this.$refs.deposit_list).bootstrapTable('refresh')
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg("出错啦");
					})
				})
			},
			// 导入xls文件
			addXlsFun: function() {
				this.$refs.depositXlsFile.click();
			},
			// 导入
			uploadDepositXls: function(e) {
				let _this = this;

				let formData = new FormData();
				formData.append("file", $("#depositXlsFile")[0].files[0]);
				// 清除file
				let obj = document.getElementById('depositXlsFile');
				obj.value = '';

				$.ajax({
					type: "post",
					dataType: "json",
					processData: false,
					contentType: false,
					url: Vue.ctUrl + "Deposit/import",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: formData,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg('导入成功');
							$(_this.$refs.deposit_list).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							// layer.msg(data.response.error_msg);
							layer.open({
                                type: 1,
                                title: '导入失败，数据错误，请修正数据后重新导入！',
                                skin: 'import-err', // 加上边框
                                area: ['700px', ''],
                                content: data.response.error_msg
                            });
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取门店下仓库
			getShopStore: function(shop_id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getStoreList",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let storeList = [];
							$.each(data.response.result, function(k, v) {
								storeList.push({ id: v.id, text: v.name });
							});
							// $(_this.$refs.deposit_edit_store).val('').trigger('change');
							$(_this.$refs.deposit_edit_store).html('<option value=""></option>');
							$(_this.$refs.deposit_edit_store).select2({
								data: storeList,
								allowClear: true,
								language: "zh-CN",
								minimumResultsForSearch: -1,
								width: '100%'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {}
				});
			},
			// 选择仓库
			selStore: function(conf, id) {
				let _this = this;

				layer.confirm('', {
					skin: 'add_goods-alert',
					type: 1,
					btn: ['确定', '取消'],
					title: ['手动充公', true],
					area: ['560px', ''],
					content: $(_this.$refs.deposit_edit),
					offset: '100px'
				}, function() {
					if($(_this.$refs.deposit_edit_store).val() == '') {
						layer.msg('请选择充公仓库');
						return false;
					}
					_this.cgConf(conf, id);
				});
			},
			// 充公、取消
			cgConf: function(conf, id) {
				let _this = this;
				let datas,
					url = '';
				if(conf == '-1') {
					// 充公
					datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id,
								"store_id": $(_this.$refs.deposit_edit_store).val()
							}
						},
						"comment": ""
					};
					url = Vue.ctUrl + "Deposit/confiscate";
				} else if(conf == '1') {
					// 取消充公
					datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": id,
							}
						},
						"comment": ""
					};
					url = Vue.ctUrl + "Deposit/recoverConfiscate";
				}
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: url,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.closeAll();
							$(_this.$refs.deposit_list).bootstrapTable("refresh");
							layer.msg(data.response.result.msg);
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取寄存管理详情
			getDepositDet: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Deposit/getDepositDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.theDeposit = data.response.result;
							// _this.thePayInfo = data.response.result.pay_info;
							// _this.goods_list = data.response.result.goods_info;
							_this.det_status = data.response.result.status_name
							_this.innitDetTable();
							_this.innitWineTable();
							_this.innitDetOperLogTable();
							// if(_this.refund_list.length == 0) {
							// 	$('.order-det-refund').hide();
							// } else {
							// 	_this.innitRefundTable();
							// 	$('.order-det-refund').show();
							// }
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 初始化寄存详情
			innitDetTable: function() {
				let _this = this;
				$(_this.$refs.depositDetTable).bootstrapTable("destroy");
				$(_this.$refs.depositDetTable).bootstrapTable({
					columns: [{
						field: "index",
						title: "行号",
						width: "5%",
						formatter: function(value, row, index) {
							return index + 1;
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						width: '20%'
					}, {
						field: "goods_unit_name",
						title: "单位",
						width: '20%'
					}, {
						field: "quantity",
						title: "寄存数量",
						width: '20%'
					}],
					data: _this.theDeposit.goods
				});
			},
			// 初始化取酒详情
			innitWineTable: function() {
				let _this = this;
				$(_this.$refs.depositWineTable).bootstrapTable("destroy");
				$(_this.$refs.depositWineTable).bootstrapTable({
					columns: [{
						field: "creare_time",
						title: "取酒时间",
						width: '25%'
					}, {
						field: "admin_name",
						title: "操作人",
						width: '25%'
					}, {
						field: "goods_name",
						title: "商品名称",
						width: '25%'
					}, {
						field: "quantity",
						title: "取酒数量",
						width: '25%'
					}],
					data: _this.theDeposit.take_goods
				});
			},

			// 初始化寄存详情操作记录
			innitDetOperLogTable: function() {
				let _this = this;
				$(_this.$refs.depositDetOperLogTable).bootstrapTable("destroy");
				$(_this.$refs.depositDetOperLogTable).bootstrapTable({
					columns: [{
						field: "create_time",
						title: "操作时间",
						width: '20%'
					}, {
						field: "type_name",
						title: "类型",
						width: '20%'
					}, {
						field: "admin_name",
						title: "操作人",
						width: '20%'
					}, {
						field: "remark",
						title: "备注",
						width: '20%'
					}],
					data: _this.theDeposit.operation_log
				});
			},
			// 返回列表
			backList: function() {
				this.showDepsit = true;
				this.showDepsitDet = false;
			}

		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.deposit-manage-wrap {
		.deposit-clear-alert {
			display: none;
			.notice {
				color: #f00;
			}
			.tip {
				margin: 10px 0;
			}
			.oper-log-title {
				margin: 30px 0 10px 0;
			}
		}
		.deposit-list {
			.deposit-tit-sel {
				width: 90px;
				padding: 0;
			}
			.deposit-con-val {
				padding-left: 0;
				margin-left: -1px;
			}
			.pull-right {
				button {
					margin: 0 0 0 30px;
				}
				>a {
					margin: 0 0 0 30px;
				}
				input {
					display: none;
				}
			}
			.set-export {
				padding: 0 20px 20px;
				h3 {
					font-size: 16px;
				}
				li {
					float: left;
					width: 20%;
				}
			}
		}
		.deposit-edit {
			display: none;
			width: 70%;
			margin: 20px auto;
			p {
				margin: 0 0 30px;
				color: #F00;
			}
			label {
				padding: 0;
				line-height: 32px;
				color: #5e5e5e;
				font-size: 14px;
				text-align: right;
				font-weight: normal;
			}
		}
		.deposit-det {
			button {
				margin: 0 30px 0 0;
			}
			.deposit-det-list {
				border-top: 8px solid #d7d7d7;
				padding: 0 0 20px;
				margin: 30px 0;
				background: #f3f3f3;
				h2 {
					margin: 20px 0;
					font-size: 20px;
					font-weight: normal;
					text-align: center;
				}
				label {
					height: 40px;
					padding: 0;
					margin: 0 0 0;
					line-height: 40px;
					font-size: 14px;
					text-align: right;
				}
				span {
					min-height: 40px;
					padding-left: 0;
					line-height: 40px;
					font-size: 14px;
				}
			}
			h3 {
				margin: 30px 0 20px;
				font-size: 18px;
				font-weight: normal;
			}
		}
		.temp-readonly {
			background: #fff;
		}
	}
</style>